"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImpactCounts = void 0;
var getImpactCounts = function (heatmapData) {
    var result = [];
    var rows = heatmapData.heatmapRowData;
    rows.forEach(function (e) {
        var impactCounts = getRowImpactCounts(e.cellData);
        result = result.concat(impactCounts);
    });
    return result;
};
exports.getImpactCounts = getImpactCounts;
var getRowImpactCounts = function (cellData) {
    var result = cellData.map(function (e) { return e.count; });
    return result;
};
